import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Button, Header } from "@pentabd/ui";
import { IconDotpoints02, IconPlus, IconUserRight01 } from "@pentabd/icons";

import { ROUTES } from "@constants/routes";
import useCustomSelector from "@redux/hooks/useCustomSelector";

export const SubTaskDetailsPageHeader = ({
  id,
  id2,
}: {
  id: string | number | undefined;
  id2: string | number | undefined;
}) => {
  const { t } = useTranslation();

  const { getSingleData } = useCustomSelector(
    (store) => store.taskManagement.subTasksState,
  );

  const breadcrumbs = [
    {
      icon: <IconDotpoints02 fill="dark" size="20" />,
    },
    {
      label: t("SIDEBAR.TASK_MANAGEMENT.ALL_TASKS"),
      link: ROUTES.TASK_MANAGEMENT.ALL_TASKS,
    },
    {
      label: t("SIDEBAR.TASK_MANAGEMENT.TASKS"),
      link: `${ROUTES.TASK_MANAGEMENT.ALL_TASKS}/${id}`,
    },
    {
      label: id2
        ? getSingleData?.subtaskName
        : t("SIDEBAR.TASK_MANAGEMENT.CREATE_SUB_TASKS"),
    },
  ];

  const headerText = {
    header: id2
      ? getSingleData?.subtaskName
      : t("TM_SUB_TASKS.TASKS_CREATE.HEADING"),
  };

  return <Header breadcrumbs={breadcrumbs} headerText={headerText} />;
};
